import React, { Component } from 'react';
import { Main } from '../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import HomeBanner from './partials/HomeBanner';
import FindOnlineTutors from './partials/FindOnlineTutors';
import BottomSlider from './partials/BottomSlider';
import { itemService, globalService as gs } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';
import Rating from '@material-ui/lab/Rating';
import { Role } from '../../../helpers';

class Home extends Component {

    constructor(props) {

        super(props);
        // reset login status
        this.state = {
            loggedIn: props.authentication.loggedIn,
            TalentedTutors: null,
            loading: false
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.setState({loading: true});
        itemService.services("GET", null, {is_featured: 1, type: 'services', 'per-page': 30}).then(data => {
            this.setState({loading: false, TalentedTutors: data.items});
            //console.log('dfssdfsd', data);
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({loading: false});
        });
    }

    render() {
        const { loggedIn, TalentedTutors } = this.state;
        const { categories, authentication } = this.props;
        let cateArray = categories && categories.data ? categories.data : [];
        const user = authentication && authentication.authentication && authentication.authentication.user;
        
        return (<Main>

            <HomeBanner cateArray={cateArray} />

            <section className="learnning new-code-dev2">
                <div className="container">
                    <div className="col-md-10 col-12 mx-auto">
                        <div className="learnning-box">
                            <div className="row">
                                <div className="col-md-12"> 
                                    <h2 className="text-center">Start Learning Easy & Fast</h2>
                                </div>
                                <div className="col-md-4 col-4"> 
                                    <div className="box text-center">
                                        <div className="image">
                                            <img src="images/svg/1.svg" alt="Banner" />
                                        </div>
                                        <div className="caption">
                                            <h3><Link to="/search-tutors">Find</Link></h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-4"> 
                                    <div className="box text-center">
                                        <div className="image">
                                            <img src="/images/svg/Hand.svg" alt="Banner" />
                                        </div>
                                        <div className="caption">
                                            <h3> <Link to="/search-tutors"> Book</Link> </h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-4"> 
                                    <div className="box text-center">
                                        <div className="image">
                                        <i className="fas fa-heart"></i>
                                        </div>
                                        <div className="caption">
                                            <h3><Link to="/search-tutors">Learn</Link></h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>    
            </section>        

            <FindOnlineTutors cateArray={cateArray} /> 

            <section className="better-way my-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 pr-lg-0">
                            <h2>A Better Way to Learn with Confidence</h2>
                            <ul className="list-icon">
                                <li><p>Screen Share</p></li>
                                <li><p>Text Chat</p></li>
                                <li><p>Video Call</p></li>
                                <li><p>Share Files</p></li>
                            </ul>
                        </div>
                        <div className="col-md-6 pl-lg-0"> 
                            <div className="image"> 
                                <img className="img-fluid" src="/images/svg/better-way.svg" alt="Banner" />
                            </div>
                        </div>
                    </div>
                </div>  
            </section> 

            <section className="passion mb-5">
                <img className="img-fluid left" src="/images/left-img.png" alt="Banner" />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-md-11 text-center mx-auto my-5"> 
                            <h2>Share your passion with the world</h2>
                            <p>Be your Own Boss, come join us and earn doing what you love, set your own rate set without paying commission.
                                 We are here to help you manage your business and build your personal brand.
                            </p>
                        </div> 
                    </div>
                </div>
                {!loggedIn &&
                <div className="tutor-btn text-center">
                    <Link to="/tutor" className="btn btn-gradiant">Become a Tutor</Link>
                </div>}
            </section>

            <section className="best mb-5">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-2 col-md-12"> 
                            <h2 className="text-center">Know why <br /> we are best</h2>
                        </div> 
                        <div className="col-xl-10 col-md-12 pr-lg-0 pr-sm-0">
                            <div className="service">
                            </div>
                            <div className="col-md-11 col-12 mx-auto">
                                <div className="row">
                                    <div className="col-md-3 col-12"> 
                                        <div className="service-box text-center">
                                            <div className="image">
                                                <img src="/images/svg/Vegan-Certified.svg" alt="Banner" />
                                            </div>
                                            <div className="caption">
                                                <h5><Link to="/">Expert Tutors</Link> </h5>
                                                {/* <p>Lifelong Learning <br /> Subject Offers</p> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-12"> 
                                        <div className="service-box text-center">
                                            <div className="image">
                                                <img src="/images/svg/Verified-1.svg" alt="Banner" />
                                            </div>
                                            <div className="caption">
                                                <h5><Link to="/">Verified Profiles</Link> </h5>
                                                {/* <p>10k Plus Verified <br /> Tutors</p> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-12"> 
                                        <div className="service-box text-center">
                                            <div className="image">
                                            <img src="/images/svg/user.svg" alt="Banner" />
                                            </div>
                                            <div className="caption">
                                                <h5><Link to="/">Learning Any Time</Link> </h5>
                                                {/* <p>you can learn <br /> anytime anywhere</p> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-12"> 
                                        <div className="service-box text-center">
                                            <div className="image">
                                            <img src="/images/svg/dollar-sign.svg" alt="Banner" />
                                            </div>
                                            <div className="caption">
                                                <h5><Link to="/">Affordable Prices</Link> </h5>
                                                {/* <p>Start with $10.00 <br /> per session</p> */}
                                            </div>
                                        </div>
                                    </div>
                               
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* <section className={`talent mb-5 ${(user && user.role === Role.Tutor) ? 'd-none' : '' }`}> */}
            <section className="talent mb-5 d-none">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mb-lg-5 mb-sm-3"> 
                            <h2>Meet our Amazing Talented Tutors</h2>
                        </div>
                        <div className="col-md-12">
                            <ul className="talent-list justify-content-center">
                                {TalentedTutors && TalentedTutors.map(item => 
                                    <li key={`jhghj${item.id}`}>
                                        <div className="talent-box"> 
                                            <div className="image">
                                                <img className="img-circle rounded-circle" src={item.user.avatar} alt="Banner" width="215" height="215" />
                                            </div>
                                            <div className="text">
                                                <h5><Link to={`/search-tutors`}>{item.title}</Link></h5>
                                            </div>
                                            <div className="caption">
                                                <h4><Link color="inherit" to={`/tutor/view/${item.user.id}`}>{item.user && item.user.name}</Link></h4>
                                                <h6>{item.user && item.user.country && item.user.country.name}</h6>
                                                <div className="rating">
                                                    <Rating value={parseFloat(item.user.rating_avg)} readOnly />
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                )}
                                {TalentedTutors && TalentedTutors.length === 0 && <li>Talented tutors not found</li>}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="passion mb-5">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-5 col-md-6">
                            <img className="img-fluid" src="/images/svg/learn.svg" alt="Banner" />    
                        </div>
                        <div className="col-lg-4 col-md-6"> 
                            <h2>Learn Anywhere, Anytime</h2>
                            <p>Connect with great tutors from anywhere using tools that make it
                                 easy & awesome without leaving home.</p> 
                            <p>Work with tutors in a live lesson space including a virtual whiteboard, or chat via text, audio or video and much more…
                            </p>
                            {!loggedIn && <Link to="/login" className="btn btn-primary">Get Started</Link>}
                        </div> 
                    </div>
                </div>
            </section>

            <section className="passion mb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 text-center mx-auto"> 
                            <h2>Book and chat with a tutor today and find out how they can help your child.</h2>
                            {!loggedIn && <Link to="/login" className="btn btn-primary">Get Started</Link>}
                        </div> 
                    </div>
                </div>
            </section>

            <BottomSlider cateArray={cateArray} />

        </Main>);
    }
}

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const categoriesSelector = createSelector(
    state => state.categories,
    categories => categories
);

const mapStateToProps = createSelector(
    authenticationSelector,
    categoriesSelector,
    (authentication, categories) => ({
        authentication, categories
    })
);

export default connect(mapStateToProps)(Home);
